import React, { useState, useEffect } from 'react';
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { toast } from 'react-toastify';
import AdminSidebar from '../components/AdminSidebar';

const FinanceAccountUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const formData = new FormData();
        formData.append('modulename', 'FinnanceAccountUserList');

        const response = await fetch(`https://pwd.smartstylin.in/index.php`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (Array.isArray(data)) {
          setUsers(data);
        } else if (data && (data.status === 1 || data.code === 1 || data.success === true) && Array.isArray(data.data)) {
          setUsers(data.data);
        } else if (data && (data.status === 1 || data.code === 1 || data.success === true) && Array.isArray(data.userlist)) {
           setUsers(data.userlist);
        }
         else {
          const errorMessage = data && data.message ? data.message : 'Failed to fetch users or unexpected data format.';
          setError(errorMessage);
          toast.error(errorMessage);
          setUsers([]);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        const errorMessage = err.message || 'An error occurred while fetching users.';
        setError(errorMessage);
        toast.error(errorMessage);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <>
      <Topbar />
      <div className="d-flex" style={{ minHeight: 'calc(100vh - 56px)' }}>
        <AdminSidebar/>
        <div className="flex-grow-1 p-3 p-md-4 bg-light">
          <header className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="h2">Finance Account Users</h1>
          </header>

          <div className="bg-white p-3 p-md-4 shadow-sm rounded">
            {loading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading users...</p>
              </div>
            )}

            {error && !loading && (
              <div className="alert alert-danger" role="alert">
                Error fetching users: {error}
              </div>
            )}

            {!loading && !error && users.length === 0 && (
              <div className="alert alert-info" role="alert">
                No finance account users found.
              </div>
            )}

            {!loading && !error && users.length > 0 && (
              <div className="table-responsive">
                <table className="table table-striped table-hover table-bordered">
                  <thead  style={{
                    backgroundColor:"#1976d2"
                  }}>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">ID</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Department</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user, index) => (
                      <tr key={user.id}>
                        <td>{index + 1}</td>
                        <td>{user.id}</td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.department}</td>
                        <td>{user.phone}</td>
                        <td>
                          <button className="btn btn-sm btn-outline-primary me-1 px-2 py-1">
                            View
                          </button>
                          <button className="btn btn-sm btn-outline-secondary px-2 py-1">
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FinanceAccountUsers;